import intersection from 'lodash/intersection';
import { Permissions, Permission } from '@atlassian/cssxp-typescommon';

export const isDealDeskPerson = (permissions: Permission[]) => {
  return intersection(permissions, [Permissions.DEAL_DESK]).length > 0;
};

export const isFinancePerson = (permissions: Permission[]) => {
  return intersection(permissions, [Permissions.FINANCE_USER]).length > 0;
};

export const hasAdminAccess = (permissions: Permission[]) => {
  return intersection(permissions, [Permissions.CASSI_ADMIN]).length > 0;
};

export const hasExportControlWriteAccess = (permissions: Permission[]) => {
  return intersection(permissions, [Permissions.EXPORT_CONTROLS_WRITE]).length > 0;
};

export const isElevatedAdmin = (permissions: Permission[]) => {
  return intersection(permissions, [Permissions.CASSI_DISTURBED]).length > 0;
};
